<div class="animated fadeIn backend form-page">
    <div class="row">
        <div class="col-12">
            <div class="top-header-area">
                <div class="header-area">
                    <h3>
                        <ng-container *ngIf="!site.id; else hasId">{{site.title}}</ng-container>
                        <ng-template #hasId>
                            <a [routerLink]="['/plantingSite', site.id]">{{site.title}}</a>
                        </ng-template>
                    </h3>
                </div>
            </div>
        </div>
        <div class="col-12">
            <tabset>
                <tab id="general" (selectTab)="putTabInUrl('general')">
                    <ng-template tabHeading>
                        <i class="icon-info"></i> General information
                    </ng-template>
                    <div class="tab-header">
                        <h4>General information</h4>
                    </div>
                    <div *ngIf="selectedTab == 'general'" class="tab-body">
                        <app-general-information [site]="site" [countries]="countries$ | async"
                            [regions]="regions$ | async" [ngoPartners]="ngoPartners$ | async"
                            (onSave)="saveSite($event)" [saving]="saving" (onCancel)="cancel()">
                        </app-general-information>
                    </div>
                </tab>
                <tab [disabled]="isNew" id="plantings" (selectTab)="putTabInUrl('plantings')">
                    <ng-template tabHeading>
                        <i class="icon-grid"></i> Plantings
                    </ng-template>
                    <div class="row" *ngIf="selectedTab == 'plantings'">
                        <div class="col-12">
                            <ng-container *ngIf="!secondTab; else secondAreaTab">
                                <div class="tab-header">
                                    <h4>{{areaId ? 'Entry > Planting' : 'Plantings'}}</h4>
                                    <div *ngIf="!areaId" class="button-area">
                                        <button type="button" class="btn btn-primary"
                                            [routerLink]="['/admin', 'plantingSites', site.id, 'plantings', 'new']"
                                            *ngIf="currentUser?.permissions.canManagePlantingAreas">
                                            <i class="icon-plus icons"></i> Add
                                        </button>
                                    </div>
                                </div>
                                <div class="tab-body">
                                    <app-areas #platingSiteAreas *ngIf="!areaId; else areaEntry"
                                        [currentUser]="currentUser" [plantingSiteAreas]="site.areas"
                                        [plantingSiteId]="site.id">
                                    </app-areas>
                                    <ng-template #areaEntry>
                                        <app-areas-entry [plantingSiteId]="site.id" [siteAreas]="site.areas">
                                        </app-areas-entry>
                                    </ng-template>
                                </div>
                            </ng-container>
                            <ng-template #secondAreaTab>
                                <div class="tab-header" *ngIf="!collectionId">
                                    <button class="btn btn-link" type="button" tabindex="0"
                                        [routerLink]="['/admin', 'plantingSites', site.id, 'plantings']">
                                        <i class="icon-arrow-left-circle"></i>
                                    </button>
                                    <h4>
                                        {{selectedSiteArea.name}} >
                                        <span *ngIf="secondTab === 'videos'">Video documentation</span>
                                        <span *ngIf="secondTab === 'images'">Image documentation</span>
                                        <span *ngIf="secondTab === 'trees'">Planted trees</span>
                                    </h4>
                                    <button type="button" (click)="openModal()" *ngIf="secondTab === 'trees'"
                                     class="btn btn-primary mr-3 mt-3" style="float: right;">
                                        Add
                                    </button>
                                </div>
                                <ng-container *ngIf="secondTab === 'videos'">
                                    <div class="tab-body">
                                        <app-videos #videos [videos]="selectedSiteArea.videos"
                                            [plantingSiteAreaId]="selectedSiteArea.id">
                                        </app-videos>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="secondTab === 'images'">
                                    <div class="tab-body">
                                        <app-documentation *ngIf="!collectionId; else photosList"
                                            [siteId]="selectedSiteArea.id" [titles$]="documentationTitles$"
                                            [(collections)]="selectedSiteArea.collections">
                                        </app-documentation>
                                        <ng-template #photosList>
                                            <app-photos-list [collectionId]="collectionId" [site]="site"
                                                [siteArea]="selectedSiteArea">
                                            </app-photos-list>
                                        </ng-template>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="secondTab === 'trees'">
                                    <div class="tab-body">
                                        <app-planted-trees #plantedSpecies [totalAmount]="site.totalTrees"
                                            [areaTreeSpecies]="selectedSiteArea.species"
                                            [totalTreeSpecies]="site.species"
                                            [totalCertifiedSpecies]="site.certificates"
                                            [plantingSiteAreaId]="selectedSiteArea.id"
                                            [miscAmount]="miscAmount"
                                            [speciesDto]="speciesDto$">
                                        </app-planted-trees>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </div>
                    </div>
                </tab>
                <tab [customClass]="!currentUser?.permissions.canReadCertificates ? 'd-none' : ''" [disabled]="isNew" id="certificates"
                    (selectTab)="putTabInUrl('certificates')">
                    <ng-template tabHeading>
                        <i class="icon-badge"></i> Certificates
                    </ng-template>
                    <ng-container *ngIf="currentUser?.permissions.canReadCertificates">
                        <div class="tab-header">
                            <h4>Certificates</h4>
                        </div>
                        <div *ngIf="selectedTab == 'certificates'" class="tab-body">
                            <app-certificates [site]="site" [(certificates)]="site.certificates"
                                [customers]="customers$ | async" [countries]="customerCountries$ | async">
                            </app-certificates>
                        </div>
                    </ng-container>
                </tab>
            </tabset>
        </div>
    </div>
</div>
